import React, { Component } from 'react';
import { Modal } from 'bloomer/lib/components/Modal/Modal';
import { ModalBackground } from 'bloomer/lib/components/Modal/ModalBackground';
import { ModalCard } from 'bloomer/lib/components/Modal/Card/ModalCard';
import { ModalCardHeader } from 'bloomer/lib/components/Modal/Card/ModalCardHeader';
import { ModalCardTitle } from 'bloomer/lib/components/Modal/Card/ModalCardTitle';
import { Delete } from 'bloomer/lib/elements/Delete';
import { ModalCardBody } from 'bloomer/lib/components/Modal/Card/ModalCardBody';
import Conditional from './Conditional';
import { ModalCardFooter } from 'bloomer/lib/components/Modal/Card/ModalCardFooter';
import { Button } from 'bloomer/lib/elements/Button';
import api from '../util/api';
import moment from 'moment';
import LoadingSpinner from '../elements/LoadingSpinner';
import Animal from '../Entities/Animal';
import CommentList from './CommentList';
import { popupErrorFromServer } from '../util/helperFunctions';

interface PropTypes {
  isOpen: boolean;
  closeModal: () => void;
  animal: Animal;
}

interface StateTypes {
  comments: Comment[];
  daysOfCommentsLoaded: number;
  isLoading: boolean;
  noMoreComments: boolean;
  isFirstLoad: boolean;
}

class CommentModal extends Component<PropTypes, StateTypes> {
  state: StateTypes = {
    comments: [],
    daysOfCommentsLoaded: 14,
    isLoading: false,
    noMoreComments: false,
    isFirstLoad: true,
  };

  async fetchComments() {
    try {
      this.setState({
        isLoading: true,
      });
      const { animal } = this.props;
      const { daysOfCommentsLoaded } = this.state;
      const comments = await api.comments.get({
        aNumber: animal.aNumber,
        startDate: moment()
          .subtract(daysOfCommentsLoaded, 'days')
          .startOf('day')
          .toISOString(),
        endDate: moment()
          .endOf('day')
          .toISOString(),
      });

      const newState: StateTypes = {
        comments,
        isLoading: false,
        isFirstLoad: false,
      } as StateTypes;

      if (comments.length === this.state.comments.length) {
        newState.noMoreComments = true;
      }

      this.setState(newState);
    } catch (err) {
      popupErrorFromServer(err);
    }
  }

  shouldFetchComments(props = this.props) {
    return props.isOpen && this.state.comments.length === 0;
  }

  handleLoadMore = () => {
    this.setState(
      {
        daysOfCommentsLoaded: this.state.daysOfCommentsLoaded + 7,
      },
      this.fetchComments,
    );
  };

  async componentDidMount() {
    if (this.shouldFetchComments()) {
      this.fetchComments();
    }
  }

  async componentWillReceiveProps(nextProps: PropTypes) {
    if (this.props !== nextProps && this.shouldFetchComments(nextProps)) {
      this.fetchComments();
    }
  }

  render() {
    const { comments, daysOfCommentsLoaded, noMoreComments, isLoading, isFirstLoad } = this.state;
    const { animal, closeModal, isOpen } = this.props;

    return (
      <Modal isActive={isOpen}>
        <ModalBackground />
        <ModalCard>
          <ModalCardHeader>
            <ModalCardTitle>
              {animal.name} comments for the last {daysOfCommentsLoaded} days
            </ModalCardTitle>
            <Delete onClick={closeModal} aria-label="close" />
          </ModalCardHeader>
          <Conditional
            check={!isFirstLoad}
            alt={
              <ModalCardBody>
                <LoadingSpinner />
              </ModalCardBody>
            }
          >
            <ModalCardBody>
              <CommentList
                comments={comments}
                isLoading={isLoading}
                handleLoadMore={this.handleLoadMore}
                noMoreComments={noMoreComments}
              />
            </ModalCardBody>
          </Conditional>
          <ModalCardFooter>
            <Button onClick={closeModal}>Close</Button>
          </ModalCardFooter>
        </ModalCard>
      </Modal>
    );
  }
}

export default CommentModal;
